import dayjs, { Dayjs } from 'dayjs'
import _ from 'lodash'

type Primitiv = null | undefined | string | number | boolean
type Collectioon = { [k: string]: Values }
type Values = Primitiv | Dayjs | Collectioon | Primitiv[] | Dayjs[] | Values[] | Collectioon[]

export default function formatAllDatesAsStrings(data: Values): Values {
    if (dayjs.isDayjs(data)) {
        // return data.format('YYYY-MM-DD')
        return data.toISOString()
    } else if (_.isArray(data)) {
        return data.map(item => {
            return formatAllDatesAsStrings(item)
        })
    } else if (_.isObject(data)) {
        const newData = { ...data }

        for (const key in newData) {
            newData[key] = formatAllDatesAsStrings(newData[key])
        }

        return newData
    } else {
        // примитив
        return data
    }
}

// const testObj = {
//     a: 'a',
//     b: dayjs(),
//     c: ['cc', dayjs()],
//     d: ['dd', { ddd: dayjs() }],
//     e: {
//         ea: ['23', '43'],
//         eb: dayjs(),
//     },
// }

// console.log(format20(testObj))

// export default function formatAllDatesAsStrings(initialData: Data) {
//     const data = { ...initialData }

//     for (const key in data) {
//         const value = data[key]

//         if (value.$isDayjsObject) {
//             data[key] = value.format('YYYY-MM-DD')
//         } else if (_.isArray(value)) {
//             const array = [...value]

//             for (let i = 0; i < array.length; i++) {
//                 const element = array[i]

//                 if (element.$isDayjsObject) {
//                     array[i] = element.format('YYYY-MM-DD')
//                 }
//             }

//             data[key] = array
//         } else if (_.isObject(value)) {
//             formatAllDatesAsStrings(value)
//         }
//     }

//     return data
// }
